import React, { FC, useCallback, useState } from "react";
import Page from "../common/navigation/Page";
import FormFields from "../common/form/FieldsList";
import FormButtons from "../common/form/Buttons";
import F7 from "../../utils/F7";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { Field } from "../common/form/FieldHandler";
import { useCreateProject } from "../../hooks/database/usePouchCreate";

const ProjectCreatePage: FC = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState<Record<string, Omit<Field, "key">>>({
    name: {
      label: "Name",
      type: "text",
      value: "",
    },
    desc: {
      label: "Desc",
      type: "text",
      value: "",
    },
  });

  const { execute: createProject } = useCreateProject();

  const handleSave = useCallback(async () => {
    const projectName = form.name.value as string;
    const projectdesc = form.desc.value as string;
    if (!projectName || projectName.length < 1) {
      F7.alert("", "Name is required");
      return;
    }
    if (!projectdesc || projectdesc.length < 1) {
      F7.alert("", "Desc is required");
      return;
    }
    const proj = await createProject({ name: projectName });
    navigate(`../${proj._id}`);
  }, [createProject, form.name.value, form.desc.value, navigate]);

  const handleCancel = useCallback(() => {
    navigate("../");
  }, [navigate]);

  const handleFormChange = useCallback(
    (field: keyof typeof form, value: Field["value"]) => {
      const local = _.cloneDeep(form);
      local[field].value = value as string;
      setForm(local);
    },
    [form],
  );

  return (
    <Page title="Add Project">
      <FormFields fields={form} onChange={handleFormChange} />
      <FormButtons onSave={handleSave} onCancel={handleCancel} />
    </Page>
  );
};

export default ProjectCreatePage;
